<template>
  <v-row>

        <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="start_date"
    >
      <label class="title-label"
        >Start Date*
        <tip-icon>
          Select the date when the need is scheduled to start.
        </tip-icon>
      </label>
      <v-menu
        v-model="startDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formattedStartDate"
            label="Select Start Date"
            readonly
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            :error-messages="startDateErrorMessage"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            :disabled="false"
          />
        </template>
        <v-date-picker
          v-model="need.start_date"
          :min="new Date().toISOString().substr(0, 10)"
          @input="startDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="end_date"
    >
      <label class="title-label"
        >End Date*
        <tip-icon>
          Select the date when the need is scheduled to end.
        </tip-icon>
      </label>
      <v-menu
        v-model="endDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formattedEndDate"
            label="Select End Date"
            readonly
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            :error-messages="endDateErrorMessage"
          />
        </template>
        <v-date-picker
          v-model="need.end_date"
          :min="endDateMinimum"
        ></v-date-picker>
      </v-menu>
    </v-col>

    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="shift_hours"
    >
      <label class="title-label">Shift Hours* </label>
      <v-text-field
        v-model="hours"
        label="Example: 4 or 3.5"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        type="number"
        autocomplete="off"
        :error-messages="hourMessage"
        @input="hourMessage = null"
      />
    </v-col>
    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="shift_capacity"
    >
      <label class="title-label"
        >Shift Capacity*
        <tip-icon>
          Enter the number of volunteer spots available.
        </tip-icon>
      </label>
      <v-text-field
        v-model="capacity"
        label="Example: 30"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        type="number"
        :min="1"
        autocomplete="off"
        :error-messages="shiftcapacityMessage"
        @input="onCapacityInput"
      />
    </v-col>
    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="shift_start_date"
    >
      <label class="title-label">Shift Date/Time* </label>
      <v-menu
        v-model="date_picker"
        :close-on-content-click="false"
        :return-value.sync="startDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :top="$vuetify.breakpoint.xs"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="timeStr"
            label="MM/DD/YYYY 00:00 am"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            solo
            flat
            outlined
            dense
            readonly
            v-bind="attrs"
            v-on="on"
            autocomplete="off"
            :error-messages="timeMessage"
          />
        </template>
        <v-date-picker
          v-model="startDate"
          scrollable
          class="date-picker"
          :min="need.start_date || minDate"
          :max="need.end_date || null"
        >
          <div style="height: 36px" />
        </v-date-picker>
        <v-time-picker v-model="startTime" scrollable class="time-picker">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="date_picker = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="onSaveDate(startTime)">
            OK
          </v-btn>
        </v-time-picker>
      </v-menu>
    </v-col>

    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
    >
      <label class="title-label"> </label>
      <div :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'">
        <v-btn dark color="primary" @click="addShift" class="mb-5">
          {{ addShiftLabelComputed }}
        </v-btn>
        <div v-for="shift in custom_shifts" :key="shift.date">
          <v-icon @click="onRemove(shift)" class="mr-1">mdi-close</v-icon>
          <span>{{ getFormattedString(shift) }}</span>
        </div>
      </div>
    </v-col>

  </v-row>
</template>
<script>
import TipIcon from "@/components/common/TipIcon.vue";
import dateFormat from "dateformat";
export default {
  components: { TipIcon },
  props: {
    need: Object,
    capacityMessage: String,
    startDateErrorMessage: String,
    endDateErrorMessage: String,
    addShiftLabel: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      timeStr: "",
      hours: "",
      capacity: "",
      startDate: null,
      date_picker: false,
      startTime: null,
      timeMessage: null,
      hourMessage: null,
      shiftcapacityMessage: null,
      custom_shifts: [],
      minDate: "2021-01-01",
      startDateMenu: false,
      endDateMenu: false,
      endDate: null,
      end_date_picker: false,
      endDateStr: "",
      endDateMessage: null
    };
  },
  computed: {
    formattedStartDate() {
      // if (!this.need.start_date) return "";
      // const date = new Date(this.need.start_date);
      // const month = String(date.getMonth() + 1).padStart(2, "0");
      // const day = String(date.getDate()).padStart(2, "0");
      // const year = date.getFullYear();
      // return `${month}/${day}/${year}`;
      if (!this.need.start_date) return "";
      const [year, month, day] = this.need.start_date.split("-");
      return `${month}/${day}/${year}`;
    },
    formattedEndDate() {
      // if (!this.need.end_date) return "";
      // const date = new Date(this.need.end_date);
      // const month = String(date.getMonth() + 1).padStart(2, "0");
      // const day = String(date.getDate()).padStart(2, "0");
      // const year = date.getFullYear();
      // return `${month}/${day}/${year}`;
      if (!this.need.end_date) return "";
      const [year, month, day] = this.need.end_date.split("-");
      return `${month}/${day}/${year}`;
    },
    addShiftLabelComputed() {
      // Use the prop if provided, otherwise fallback to computed logic
      if (this.addShiftLabel) return this.addShiftLabel;
      if (this.need && this.custom_shifts && this.custom_shifts.length > 0) {
        return "Add Additional Shift";
      }
      return "Add First Shift";
    },
    endDateMinimum() {
    // If start date is selected, use that as minimum for end date
    // Otherwise, use today as minimum
    if (this.need.start_date) {
      return this.need.start_date;
    }
    return new Date().toISOString().substr(0, 10);
  },
  shiftDateMinimum() {
    // If start date is selected, use that as minimum for shift date
    // Otherwise, use today as minimum
    if (this.startDate) {
      return this.startDate;
    }
    return new Date().toISOString().substr(0, 10);
  },
  },

  methods: {
    onCapacityInput(value) {
      const numericValue = value.replace(/[^0-9]/g, "");
      if (numericValue === "" || Number(numericValue) < 1) {
        this.need.capacity = 1;
      } else {
        this.need.capacity = Number(numericValue);
      }
    },
    onSaveDate() {
      if (!this.startTime && !this.startDate) return;
      if (!this.startDate || !this.startTime) return;
      // Combine date and time into a single Date object
      const [hour, minute] = this.startTime.split(':');
      const dateObj = new Date(this.startDate);
      dateObj.setHours(Number(hour));
      dateObj.setMinutes(Number(minute));
      this.timeStr = dateFormat(dateObj, "yyyy-mm-dd hh:MM TT");
      this.date_picker = false;
    },
    addShift() {
      // Reset error messages
      this.timeMessage = null;
      this.hourMessage = null;
      this.shiftcapacityMessage = null;

      // Validate Shift Hours
      if (!this.hours || Number(this.hours) <= 0) {
        this.hourMessage =
          "Shift Hours are required and must be greater than 0.";
      }

      // Validate Shift Capacity
      if (!this.capacity || Number(this.capacity) <= 0) {
        this.shiftcapacityMessage =
          "Shift Capacity is required and must be greater than 0.";
      }

      // Validate Shift Start Date/Time
      if (!this.timeStr) {
        this.timeMessage = "Shift Date/Time is required.";
      }

      // Stop if any validation fails
      if (
        this.hourMessage ||
        this.shiftcapacityMessage ||
        this.timeMessage
      ) {
        return;
      }

      // Add Shift Logic
      if (!this.need.custom_shifts) this.need.custom_shifts = [];
      const shift = this.need.custom_shifts.find(
        s => s.start_date === this.timeStr
      );

      if (shift) {
        this.timeMessage = "A shift with the same time already exists.";
      } else {
        this.need.custom_shifts.push({
          start_date: this.timeStr,
          hours: this.hours,
          capacity: this.capacity
        });
        this.custom_shifts = [...this.need.custom_shifts];
        
        // Emit event to parent to trigger validation update
        this.$emit('shifts-updated', this.need.custom_shifts);
        
        this.timeStr = "";
        this.hours = "";
        this.capacity = "";
      }
    },
    
    onRemove(shift) {
      this.need.custom_shifts = this.need.custom_shifts.filter(
        s => s.start_date !== shift.start_date
      );
      this.custom_shifts = [...this.need.custom_shifts];
      
      // Emit event to parent to trigger validation update
      this.$emit('shifts-updated', this.need.custom_shifts);
    },

    getFormattedString(shift) {
      var date = Date.parse(shift.start_date || shift.date);
      return (
        dateFormat(date, "mmm dd, yyyy 'at' hh:MM tt 'for '") +
        shift.hours +
        " hours with " +
        shift.capacity +
        " slots."
      );
    }
  },
  mounted() {
    this.minDate = dateFormat(new Date(), "yyyy-mm-dd");
    // Remove auto-set of start_date, let user pick it
    if (this.need.custom_shifts && Array.isArray(this.need.custom_shifts)) {
      this.custom_shifts = [...this.need.custom_shifts];
    }
  },
  watch: {
    'need.custom_shifts': {
      handler(newShifts) {
        if (newShifts && Array.isArray(newShifts)) {
          this.custom_shifts = [...newShifts];
        }
      },
      immediate: true,
      deep: true
    },
    
    timeStr(value) {
      if (value) {
        this.timeMessage = null;
      }
    }
  }
};
</script>
<style scoped>
.title-label {
  width: 200px;
}
.date-picker {
  border-radius: 4px 0 0 4px;
}
.time-picker {
  border-radius: 0 4px 4px 0;
}
.date-picker :deep(.v-picker__title) {
  max-height: 87px;
}
.time-picker :deep(.v-picker__title) {
  max-height: 87px;
}
</style>
